/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.2.0
 */

import get from 'lodash/get';
import { createSelector } from 'reselect';
import { OutputSelector } from 'reselect/src';

import { IRootReducer } from '../../../reducers/rootReducer';
import { ILoginRecoveryState } from '../types/authTypes';
import { IRecoveryState } from '../types/recoveryTypes';

/**
 * Selector returns recovery state
 * @param {IRootReducer} state
 * @returns {IRecoveryState}
 */
export const getRecoveryState = (state: IRootReducer) => state.auth.recovery;

/**
 * Selector returns ILoginRecoveryState or null
 * @returns {OutputSelector<IRootReducer, ILoginRecoveryState | null, {}>}
 */
export const makeSelectRecovery = (): OutputSelector<IRootReducer, ILoginRecoveryState | null,
    (state: IRecoveryState) => ILoginRecoveryState | null> =>
    createSelector(
        getRecoveryState,
        (state: IRecoveryState) => get(state, 'loginRecovery', null ),
    );

/**
 * Selector returns question or null
 * @returns {OutputSelector<IRootReducer, string | null, {}>}
 */
export const makeSelectRecoveryQuestion = (): OutputSelector<IRootReducer, string | null,
    (state: IRecoveryState) => string | null> =>
    createSelector(
        getRecoveryState,
        (state: IRecoveryState) => get(state, 'loginRecovery.question.text', null),
    );
